import React, { useEffect, useState } from 'react';
import ProductCard from './ProductCard';
import FloatingCartButton from '../FloatingCartButton';
import '../../styles/CatalogPage.css';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import {getStoreObj, setStoreObj} from '../../utils/storage';
import StoreInfo from "../StoreInfo";
import Modal from "./Modal";
import {clearCart, getCart} from "../../api/cartAPI";
import {getProducts} from "../../api/productsAPI";


const CatalogPage = () => {
    const navigate = useNavigate();
    const location = useLocation()
    const storeObj = location.state?.storeObj;
    const { storeId } = useParams();
    const [products, setProducts] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [cart, setCart] = useState([]);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState(null);


    useEffect(() => {
        // Проверяем, совпадают ли storeId из URL и из состояния
        if (storeObj?.store_id !== storeId) {
            console.warn(`Store ID mismatch: Expected ${storeObj?.store_id}, but got ${storeId}.`);
        }

        if (getStoreObj() === null) {
            setStoreObj(storeObj)
        }

        const fetchData = async () => {
            setIsLoading(true);
            try {
                const [productsData, cartData] = await Promise.all([
                    getProducts(storeId),
                    getCart()
                ]);
                console.log('Fetched products and cart:', { productsData, cartData });
                setProducts(productsData);
                setCart(cartData);
            } catch (error) {
                console.error('Error fetching data:', error);
                setError('Помилка при завантаженні даних. Спробуйте пізніше.');
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [storeId]);

    const filteredProducts = products.filter((product) =>
        product.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleClearCart = async () => {
        try {
            await clearCart();
            setCart([]);
            setStoreObj(null);
            setShowModal(false);
        } catch (error) {
            console.error('Failed to clear the cart:', error);
            setError('Помилка при очищенні кошика.');
        }
    }

    // Обработка случаев пустого каталога
    const renderProducts = () => {
        if (isLoading) return <p>Завантаження...</p>;
        if (error) return <p className="error-message">{error}</p>;
        if (!filteredProducts.length) return <p>Немає доступних товарів з цього магазину</p>;
        return filteredProducts.map((product) => (
            <ProductCard
                key={product.product_id}
                product={product}
                cart={cart}
                localStoreObj={storeObj}
                onAddToCart={(product) => setCart([...cart, product])}
                onRemoveFromCart={(productId) => {
                    const newCart = cart.filter((item) => item !== productId)
                    setCart(newCart);
                    if ( newCart.length === 0 ) {
                        setStoreObj(null)
                    }
                }}
                onShowModal={() => {
                    setModalData({ productId: product.product_id });
                    setShowModal(true);
                }}
            />
        ));
    };

    return (
        <div className="catalog-page">

            <h1>Каталог</h1>
            <StoreInfo store={storeObj}/>


            <div className="search-container">
                <img src="/images/search-icon.svg" alt="search" className="search-icon"/>
                <input
                    type="text"
                    placeholder="Пошук товарів"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="product-search"
                />
            </div>

            <div className="product-grid">{renderProducts()}</div>

            {cart.length > 0 && <FloatingCartButton cartItems={cart.length} />}

            {showModal && (
            <Modal
                onClose={() => setShowModal(false)}
                onViewOrder={() => {
                    setShowModal(false);
                    // Логика перехода к заказу:
                    navigate('/cart');
                }}
                onClearCart={handleClearCart}
             />
            )}
        </div>
    );
};

export default CatalogPage;
